/** Маршруты приложения: Earn — домашняя (`/`). */
export const ROUTE_PATHS = {
	earn: '/',
	portfolio: '/portfolio',
	profile: '/profile',
} as const;

/** Имена записей в `router` — для `route.name`, `{ name }` в `RouterLink` / `router.push`. */
export const ROUTE_NAMES = {
	earn: 'earn',
	portfolio: 'portfolio',
	profile: 'profile',
} as const;
